@ -1,638 +0,0 @@
<template>
    <sys-register-base 
        :loading="loading" 
        @onSave="saveAll" 
        :model.sync="model" 
        :title="title" 
        icon="mdi-book-open-page-variant"
        v-bind:show.sync="dialog"
        maxWidth="100%"
        :showRequiredFields="false"
        :showButton="false"
    >
        <template v-slot:form>
            <v-container fluid>
                    <v-row>
                        <v-col cols="12" sm="12">
                            <v-progress-linear
                                v-if="loading"
                                indeterminate
                                color="cyan lighten-4"
                            />
                            <v-data-table
                                v-if="renderComponent"
                                :items="items"
                                :headers="headers.filter(h => h.visible)"
                                sort-by="calories"
                                class="elevation-1"
                                item-key="index"
                                :hide-default-footer="true"
                                :items-per-page="-1"
                                fixed-header
                                height="400"
                            >
                                <template v-slot:top>

                                     <v-btn
                                        v-if="showAddItem" 
                                        icon
                                        color="primary"
                                        @click="addItem()"  
                                    >
                                        Adicionar Marcação    
                                        <v-icon>mdi-plus</v-icon>
                                    </v-btn>
                                
                                </template>


                                <template dense v-slot:item.date="{ item, index }">
                                    
                                    <emc-calendar-date-picker2
                                        :model.sync="item.date" 
                                        label="" 
                                        :error="errors.length > 0"
                                        :error-messages="errors['items.' + index + '.date']" 
                                        :show="dialog"
                                        :min="dateMin"
                                        :max="dateMax"
                                        :allowed-dates="allowedDates"
                                        dense
                                        :disabled="((item.id && userType == 'teacher') || item.occurrence_type_id != null) ? true : false"
                                    />

                                    
                                </template>

                                <template v-slot:item.hour="{ item, index }">
                                    <!-- Períodos -->
                                    <emc-calendar-time-picker 
                                        v-for="(period, i) in [periods[0], periods[1]]"
                                        :key="i"
                                        :classText="i === 0 ? 'mt-4' : null"
                                        dense 
                                        :error="!!errors[period]" 
                                        :errors="errors['items.' + index + '.' + period]" 
                                        :time.sync="item[period]" 
                                        :label="i % 2 == 0 ? 'Início' : 'Fim'"
                                        clearable
                                        :disabled="((item.id && userType == 'teacher') || item.occurrence_type_id != null) ? true : false"
                                    />

                                </template>

                                <template dense v-slot:item.description="{ item, index }">
                                    
                                    <v-textarea
                                        class="mt-2"
                                        v-model="item.description"
                                        :error="errors.length > 0"  
                                        :error-messages="errors['items.' + index + '.description']"
                                        label=""
                                        rows="3"
                                        auto-grow
                                        outlined
                                        :disabled="((item.id && userType == 'teacher') || item.occurrence_type_id != null) ? true : false"
                                    />

                                </template>
                                
                                <!-- Marcações -->
                                <template dense v-slot:item.mark="{ item, index }">
                                    <emc-calendar-time-picker 
                                            v-for="(mark, i) in [markings[0], markings[1]]"
                                            :classText="i === 0 ? 'mt-4' : null"
                                            :key="i"
                                            dense 
                                            :error="!!errors[mark]" 
                                            :errors="errors['items.' + index + '.' + mark]" 
                                            :time.sync="item[mark]" 
                                            :label="i % 2 == 0 ? 'Entrada' : 'Saída'"
                                            clearable
                                            :disabled="item.occurrence_type_id != null"
                                        />

                                </template>

                                <!-- <template v-for="(mark, i) in markings" v-slot:[`item.${mark}`]="{ item, index }">
                                        
                                </template> -->

                                <template dense v-slot:item.type="{ item}">

                                    <span v-if="item.type">
                                        <emc-info-help v-if="item.note || item.motive" title="Justificativa">
                                            <template v-slot:text>
                                                <span v-if="item.motive">{{ item.motive.name }}</span>
                                                <small v-if="item.note"><br/>{{ item.note }}</small>
                                            </template>
                                        </emc-info-help>
                                        {{ item.type.name }}
                                    </span>

                                </template>

                                <!-- <template dense v-slot:item.occurrence_status_id="{ item, index }">
                                    <sys-select-occurrence-status
                                        :model.sync="item.occurrence_status_id"
                                        :error="errors.length > 0"  
                                        :errors="errors['items.' + index + '.occurrence_status_id']"
                                        label=""
                                    />
                                </template> -->

                                <template v-slot:item.actions="{ item, index }">

                                    <emc-button-icon
                                        v-if="!hideEdit"
                                        :loading="index == indexItem && loadingUpdate"
                                        icon="mdi-content-save-outline"
                                        color="success"
                                        @click="updateItem(item, index)"
                                         :disabled="disabledActions || item.occurrence_type_id != null"
                                         text="Salvar"
                                         iconSmall
                                    />

                                    <emc-button-icon
                                        v-if="!hideDelete"
                                        :loading="index == indexItem && loadingDelete"
                                        :icon="userType == 'user' ? 'mdi-delete' : 'mdi-calendar-minus'"
                                        color="primary"
                                        @click="showDeleteItem(item, index)"
                                        :disabled="disabledActions || item.occurrence_type_id != null"
                                        :text="userType == 'user' ? 'Excluir' : 'Cadastrar Ocorrência'"
                                        iconSmall
                                    />
                                </template>
                            
                            </v-data-table>
                        </v-col>
                    </v-row>
            </v-container>


            <!-- Exclusão -->
            <emc-alert-modal title="Ocorrências de Ponto" icon="mdi-book-open-page-variant" :text="userType == 'user' ? 'Confirma a exclusão do registros?' : 'Confirma o cadastro da ocorrência?'" :disabled="loadingDelete" v-bind:show.sync="showFormDeleteItem">
                
                <template v-slot:content>
                        <v-row>
                            <v-col  cols="12" sm="12">
                                <sys-select-occurrence-type
                                    :model.sync="occurrence_type_id"
                                    label="Tipo de Ocorrência*"
                                    filterAdditional="0"
                                    hideHolliday
                                    hidePreMarked
                                />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col  cols="12" sm="12">
                                <sys-select-occurrence-motive
                                    :model.sync="occurrence_sheet_register_motive_id"
                                    label="Motivo*"
                                />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-textarea
                                v-if="userType == 'teacher'"
                                v-model="note" 
                                :label="'Justificativa (Mínimo ' + minNote +  '  caracteres)'"
                                :counter="maxNote"
                                :rules="[v => (!v || v.length <= maxNote) || 'Máximo de 255 caracteres atingido']"
                                outlined
                                :aria-placeholder="'Informe uma justificativa com no mínimo' + minNote + 'caracteres'"
                            />
                        </v-row>

                </template>
                
                <template v-slot:actions>
                    <v-btn v-if="userType == 'user'"  color="primary" @click.prevent.stop="deleteItem()" :loading="loadingDelete" :disabled="loadingDelete">Excluir<v-icon right dark>mdi-delete</v-icon></v-btn>
                    <v-btn v-else-if="userType == 'teacher'"  color="primary" @click.prevent.stop="absenceItem()" :loading="loadingDelete" :disabled="disabledSave">Cadastrar Ocorrência<v-icon right dark>mdi-calendar-minus</v-icon></v-btn>
                </template>

            </emc-alert-modal>

            <!-- Alert para mensagens -->
            <emc-alert-snackbar :show="!! message.length"  :message="message" :color="error ? 'error' : 'success'"/>
        </template>
       
    </sys-register-base>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
    name: "SysOccurrenceSheetItemRegister",
    data: (vm) => ({
        dialog: false,
        error: false,
        errors: {},
        message: '',
        selectedDeleteItem: null,
        showFormDeleteItem: false,
        occurrence_type_id: null,
        dateMin: null,
        dateMax: null,
        allowedDates: null,
        position: null,
        occurrence_sheet_register_motive_id: null,
        minNote: 5,
        maxNote: 255,
        note: null,
        indexItem: -1,
        disabledActions: false,
        items: [],
        loading: false,
        loadingUpdate: false,
        loadingDelete: false,
        renderComponent: true,
        periods: ['hour_start1', 'hour_end1', 'hour_start2', 'hour_end2', 'hour_start3', 'hour_end3',],
        markings: ['check_in_1', 'check_out_1', 'check_in_2', 'check_out_2', 'check_in_3', 'check_out_3',],
        headers: [
            { text: 'Data',         value: 'date',                  align: 'start', sortable: false, visible: true, width: '15%' },
            { text: 'Horário',      value: 'hour',                  align: 'start', sortable: false, visible: true, width: '10%'  },
            { text: 'Descrição',    value: 'description',           align: 'start', sortable: false, visible: true, width: '35%'  },
            { text: 'Marcação',     value: 'mark',                  align: 'start', sortable: false, visible: vm.showEditMark, width: '10%'  },
            { text: 'Ocorrência',   value: 'type',                  align: 'center',sortable: false, visible: true, width: '10%'  },
            { text: 'Status',       value: 'occurrence_status_id',  align: 'center',sortable: false, visible: false, width: '10%'  },
            { text: '',             value: 'actions',               align: 'center',sortable: false, visible: true, width: '10%' },
        ],
    }),
    created(){

    },

    computed: {
      ...mapState('auth', ['acesso']),

      disabledSave(){
            
            return this.loadingDelete || this.note === null || this.note.length < this.minNote || this.note.length > this.maxNote || !this.occurrence_type_id || !this.occurrence_sheet_register_motive_id;

        },

    },

    watch: {
        
        dialog(dialog_new, dialog_old) {
            
            if(dialog_new !== dialog_old) {
                this.$emit('update:show', dialog_new)
            }

        },

        show(show_new, show_old) {
            
            this.dialog = show_new;

            if(show_new){
                
                
                this.dateMin = this.model.info_date.start;
                this.dateMax = this.model.info_date.end;

                if(this.userType == 'teacher'){
                    
                    this.allowedDates = this.model.info_date.allowed_dates;

                }
                
                this.error = false;
                this.errors = {};
                this.getData();
                this.getLocation();


            }
        },
        
    },
    props: {
        model: {
            type: Object,
            required: true
        },
        color: {
            type: String,
            default: 'grey lighten-5'
        },
        width: {
            type: String,
            default: "500"
        },
        maxWidth: {
            type: String,
            default: "80%"
        },
        icon: {
            type: String,
            default: "mdi-alert"
        },
        title: {
            type: String,
            default: "Marcações de Ponto"
        },
        text: {
            type: String,
            default: ""
        },
        show: {
            type: Boolean,
            default: false
        },
        hideDelete: {
            type: Boolean,
            default: false
        },
        hideEdit: {
            type: Boolean,
            default: false
        },
        showAddItem: {
            type: Boolean,
            default: false
        },
        showEditMark: {
            type: Boolean,
            default: true
        },
        userType: {
            type: String,
            default: 'user'
        }

    },
    methods:{
        ...mapActions('timeSheet', ['ActionIndexOccurrenceSheetItems', 'ActionUpdateOccurrenceSheet', 'ActionStoreOccurrenceSheetItem', 'ActionUpdateOccurrenceSheetItem', 'ActionDestroyOccurrenceSheetItem', 'ActionAbsenceRegisterSheetItem']),

        getData(){

                this.loading = true;
                this.items = [];

                var payload = {
                    find_columns: {
                        occurrence_sheet_id: this.model.id,
                    },
                    with: 'registers,type,motive,sheet.activityItems.activity',
                }

                this.ActionIndexOccurrenceSheetItems(payload)
                    .then((res) => {
                        this.items = res.data;
                    })
                    .finally(() => {
                        this.loading = false;
                        this.loadMarks();
                    });

        },

        getLocation()
        {
            if (navigator.geolocation)
            {
                navigator.geolocation.getCurrentPosition((pos) => {
                    
                    this.position = {
                        lat: pos.coords.latitude,
                        lng: pos.coords.longitude
                    };
                });
            }
            
        },

        loadMarks(){

            this.items.forEach(item => {
                
                let index = 0;
                
                for (let i = 0; i < item.registers.length; i++) {
                    
                    let reg = item.registers[i];
                    
                    if(reg.action == 'I' || reg.action == 'U'){
                        item[this.markings[index++]] = reg.time;
                    }
                }
            });

        },
        
        saveAll(){
            
            this.loading = true;
            this.error = false;
            this.errors = {};

            this.items.forEach(item => {
                this.loadRegisters(item);
            });
            
            this.ActionUpdateOccurrenceSheet(this.model)
                .then((res) => {
                    item.registers = res.registers;
                })
                .catch((error) =>{
                    this.error = true;
                    this.errors = error.errors;
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        removeItem(item){
          var index = this.items.indexOf(item);
          this.items.splice(index, 1);
          this.showFormDeleteItem = false;
          this.forceRerender();
        },

        updateItem(item, index){
          
          var method = item.id ? 'ActionUpdateOccurrenceSheetItem' : 'ActionStoreOccurrenceSheetItem';
          this.loadingUpdate = true;
          this.indexItem = index;
          this.error = false;
          this.errors = {};
            

          this.loadRegisters(item);

          this[method](item)
            .then((res) => {
                item.registers = res.data.registers;
            })
            .catch((error) =>{
                Object.keys(error.errors).forEach(key => {
                    this.errors['items.' + index + '.' + key] = error.errors[key];
                });
                this.error = true;
            })
            .finally(() => {
                  this.loadingUpdate = false;
                  this.indexItem = -1;
                  //this.forceRerender();
            });
            
      },

      loadRegisters(item){

        let registersOriginal = item.registers;
        let registers = [];
        
        for (let i = 0; i < this.markings.length; i++) {
                
                let date    = item.date;
                let time    = item[this.markings[i]];
                
                if(time){

                    let reg = registersOriginal.find(r => (r.time == time && r.date == date));

                    if(reg){
                        registers.push(reg);
                    }else{
                        registers.push({
                            id:                                 0,
                            occurrence_sheet_item_id:           item.id,
                            occurrence_intervention_type_id:    this.userType == 'user' ? 2 : 1, // 2 = Incluído | 4 = Exceção
                            date:                               date,
                            time:                               time,
                            localization:                       this.position ? (this.position.lat + ';' + this.position.lng) : null,
                        });
                    }

                }

            }

            item.registers = registers;
      },

      showDeleteItem(item, index)
      {
        
        this.selectedDeleteItem = item;
        this.indexItem = index;
        this.note = null;
        this.occurrence_type_id = null;
        this.showFormDeleteItem = true;
           
      },

      deleteItem(){
          
          let item = this.selectedDeleteItem;
          
          if(!item.id){
            this.removeItem(item);
            return;
          }
          
          this.loadingDelete = true;
          this.error = false;
          this.errors = {};
          let payload = {
            id: item.id,
          };
          
          this.ActionDestroyOccurrenceSheetItem(payload)
            .then((res) => {
                this.removeItem(item);
            })
            .catch((error) =>{
                
                
            })
            .finally(() => {
                  this.loadingDelete = false;
                  this.indexItem = -1;
                  this.showFormDeleteItem = false;
                  this.selectedDeleteItem = null;
                  this.forceRerender();
            });
            
      },

      absenceItem(){
          
          let item = this.selectedDeleteItem;
          
          this.loadingDelete = true;
          this.error = false;
          this.errors = {};
          let payload = {
            id: item.id,
            note: this.note,
            occurrence_type_id: this.occurrence_type_id,
            occurrence_sheet_register_motive_id: this.occurrence_sheet_register_motive_id,
          };
          
          this.ActionAbsenceRegisterSheetItem(payload)
            .then((res) => {
                
            })
            .catch((error) =>{
                
                
            })
            .finally(() => {
                  this.loadingDelete = false;
                  this.indexItem = -1;
                  this.showFormDeleteItem = false;
                  this.selectedDeleteItem = null;
                  this.getData();
            });
      },

      addItem(){
          
          if(!this.model){
            return;
          }

          var length = this.items.length;
          
          var item = {
              index:                        length,
              id:                           0,
              occurrence_sheet_id:          this.model.id,
              occurrence_record_type_id:    1,
              occurrence_type_id:           null,
              occurrence_sheet_register_motive_id: null,
              occurrence_status_id:         1,
              date:                         null,
              hour_start1:                  null,
              hour_end1:                    null,
              hour_start2:                  null,
              hour_end2:                    null,
              hour_start3:                  null,
              hour_end3:                    null,
              description:                  null,
              check_in_1:                   null,
              check_out_1:                  null,
              check_in_2:                   null,
              check_out_2:                  null,
              check_in_3:                   null,
              check_out_3:                  null,
              registers:                    [],
          };

          this.items.unshift(item);
          this.forceRerender();
          
      },

      forceRerender () {
      
        this.renderComponent = false;

        this.$nextTick(() => {
            this.renderComponent = true;
        });
    }

      

    }
}
</script>